import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import * as modules from '../modules'
import { sendPasswordResetEmail, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth'
import { getFunctions, httpsCallable } from 'firebase/functions'

import { auth } from '../main'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,

  state: {
    drawer: false,
    links: [
      'Annaliis',
      'Arpeggiator',
      'Downloads',
      'Buy',
      'User Area',
      'Sign Up',
      'Sign In',
      'About Us',
      'Sound Design',
      'Tutorials',
      'Podcasts',
      'Privacy Policy'
    ],
    user: null,
    userData: 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',
    unlock: null,
    purchased: false,
    mesArpPurchased: false,
    mesArpUnlock: null,
    loading: false,
    error: null,
  },

  mutations: {
    setDrawer (state, payload) {
      state.drawer = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    setUserData (state, payload) {
      state.userData = payload
      state.unlock = payload.unlock
      state.purchased = payload.purchased
      state.mesArpUnlock = payload.mesArpUnlock
      state.mesArpPurchased = payload.mesArpPurchased
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    }
  },

  actions: {
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      createUserWithEmailAndPassword(auth, payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: auth.currentUser.uid
            }
            // console.log(`newUser: ${JSON.stringify(newUser)}`)
            commit('setUser', newUser)
            router.push({ name: 'Welcome' }) // Navigation after successful signup
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            // console.log(error)
          }
        )
    },
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      signInWithEmailAndPassword(auth, payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: auth.currentUser.uid
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            // console.log(error)
          }
        )
    },
    autoSignIn ({ commit }, payload) {
      // console.log(`autoSignIn: ${JSON.stringify(payload.uid)}`)
      commit('setUser', { id: payload.uid })
    },
    signUserOut ({ commit }) {
      auth.signOut(auth)
      commit('setUser', null)
    },
    sendRecoveryEmail ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      sendPasswordResetEmail(auth, payload.email).then(() => {
        // console.log('email sent!')
        router.push({ path: '/signin' })
      }).catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          // console.log(error)
        }
      )
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    getUserData ({ commit }, payload) {
      // console.log(`userData payload: ${JSON.stringify(payload)}`)
      const functions = getFunctions()
      let userData = httpsCallable(functions, 'getUserData')
      userData({
        data: {
          firebaseAuthUserUID: payload.user.id
        }
      })
      .then((returnedFromCloudFunction) => {
        // console.log(`Setting userData: ${JSON.stringify(returnedFromCloudFunction.data)}`)
        commit('setUserData', returnedFromCloudFunction.data)
      })
      .catch(
        error => {
          commit('setError', error)
          // console.log(error)
        }
      )
    }
  },

  getters: {
    user (state) {
      return state.user
    },
    userData (state) {
      return state.userData
    },
    unlock (state) {
      return state.unlock
    },
    purchased (state) {
      return state.purchased
    },
    mesArpUnlock (state) {
      return state.mesArpUnlock
    },
    mesArpPurchased (state) {
      return state.mesArpPurchased
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    isUserLoggedIn (state) {
      return state.user !== null
    },
  },

  plugins: [pathify.plugin],
})
